import './css/styles.scss';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function mobileNavInit() {
	const menuToggle = document.querySelector('[data-open-menu]');
	if (!menuToggle) return;

	const target = document.querySelector(`.engrate-main-nav`);
	if (!target) return;

	const closeBtn = target.querySelector('[data-menu-close]');
	if (!closeBtn) return;

	const bodyOverlay = document.querySelector('[data-menu-overlay]');

	menuToggle.addEventListener('click', () => {
		target.classList.toggle('is-open');
		menuToggle.classList.toggle('is-open');
		disableBodyScroll(target);
		if (bodyOverlay) {
			bodyOverlay.classList.toggle('-active');
		}
	});

	closeBtn.addEventListener('click', () => {
		target.classList.toggle('is-open');
		menuToggle.classList.toggle('is-open');
		enableBodyScroll(target);
		if (bodyOverlay) {
			bodyOverlay.classList.toggle('-active');
		}
	});

	if (bodyOverlay) {
		bodyOverlay.addEventListener('click', () => {
			target.classList.toggle('is-open');
			menuToggle.classList.toggle('is-open');
			bodyOverlay.classList.toggle('-active');
		});
	}
}

function initSubmenu() {
	const mobileNav = document.querySelector('.engrate-main-nav');
	if (!mobileNav) return;

	const toggleBtns = mobileNav.querySelectorAll('.toggle-button');
	if (!toggleBtns) return;

	toggleBtns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			const target = e.currentTarget as HTMLElement;
			const parent = target.parentElement;
			if (!parent) return;

			const subMenu = parent.querySelector('.sub-menu');
			if (!subMenu) return;

			if (parent.classList.contains('active')) {
				// animate slide up submenu
				parent.classList.remove('active');

				subMenu.style.height = subMenu.clientHeight + 'px';
				setTimeout(() => {
					subMenu.style.height = '0px';
				}, 0);
				setTimeout(() => {
					subMenu.style.height = '';
				}, 300);

				subMenu.setAttribute('aria-expanded', 'false');
			} else {
				// close other submenus
				const activeSubMenus = mobileNav.querySelectorAll('.sub-menu.active');

				activeSubMenus.forEach((subMenu) => {
					subMenu.classList.remove('active');
					subMenu.style.height = subMenu.clientHeight + 'px';
					setTimeout(() => {
						subMenu.style.height = '0px';
					}, 0);
					setTimeout(() => {
						subMenu.style.height = '';
					}, 300);
				});

				parent.classList.add('active');

				// animate slide down submenu
				subMenu.style.height = 'auto';
				const height = subMenu.clientHeight + 'px';
				subMenu.style.height = '0px';
				setTimeout(() => {
					subMenu.style.height = height;
				}, 0);

				subMenu.setAttribute('aria-expanded', 'true');
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', function () {
	mobileNavInit();
	initSubmenu();
});
